import { jsx as _jsx } from "react/jsx-runtime";
import { CombinedFeaturesEnum, } from "@/types";
import { HammerIcon, HouseChimneyHeartIcon, TemperatureListIcon, PowerIcon, HouseDayIcon, FileCheckIcon, FileCertificateIcon, PaintRollerIcon, } from "@gemini/icons";
const iconMapping = {
    [CombinedFeaturesEnum.constructionYear]: _jsx(HammerIcon, {}),
    [CombinedFeaturesEnum.energy]: _jsx(PowerIcon, {}),
    [CombinedFeaturesEnum.heating]: _jsx(TemperatureListIcon, {}),
    [CombinedFeaturesEnum.state]: _jsx(HouseChimneyHeartIcon, {}),
    [CombinedFeaturesEnum.houseType]: _jsx(HouseDayIcon, {}),
    [CombinedFeaturesEnum.minergieStandard]: _jsx(HouseDayIcon, {}),
    [CombinedFeaturesEnum.validity]: _jsx(FileCheckIcon, {}),
    [CombinedFeaturesEnum.basedOn]: _jsx(FileCertificateIcon, {}),
    [CombinedFeaturesEnum.yearOfConstructionBuilding]: _jsx(HammerIcon, {}),
    [CombinedFeaturesEnum.yearOfConstructionHeating]: _jsx(HammerIcon, {}),
    [CombinedFeaturesEnum.primaryEnergySource]: _jsx(PowerIcon, {}),
    [CombinedFeaturesEnum.nameOfCertificate]: _jsx(FileCheckIcon, {}),
    [CombinedFeaturesEnum.excessiveConsumption]: _jsx(FileCertificateIcon, {}),
    [CombinedFeaturesEnum.lastModernisation]: _jsx(PaintRollerIcon, {}),
};
export const addIconToFeatures = (features) => {
    if (!(features === null || features === void 0 ? void 0 : features.length))
        return null;
    return features
        .filter(({ type }) => Object.values(CombinedFeaturesEnum).includes(type))
        .map(({ type, ...feature }) => ({
        ...feature,
        testId: type,
        icon: iconMapping[type],
    }));
};
